// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topbar_topbarContainer__has3k {
  width: 100%;
  background: white;
  border-bottom: 1px solid #e5e5e5;
  padding: 15px 25px;
  height: 67px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 9;
}

/* Left (Admin Title) */
.topbar_topbarLeft__41sNg h2 {
  font-size: 22px;
  font-weight: 600;
  margin: 0;
}

/* Right Icons */
.topbar_topbarRight__NZOkz {
  display: flex;
  align-items: center;
  gap: 20px;
}

.topbar_icon__j3uYA {
  font-size: 22px;
  cursor: pointer;
  color: #333;
  transition: 0.2s ease;
}

.topbar_icon__j3uYA:hover {
  color: #2d7a46;
}

.topbar_notificationIcon__E30Yo {
  height: 25px;
  width: 25px;
}

.topbar_notificationIcon__E30Yo img {
  height: 100%;
  width: 100%;
}

.topbar_userIcon__iQnul {
  height: 40px;
  width: 40px;
  border: 1px solid black;
  border-radius: 100%;
  cursor: pointer;
}

.topbar_userIcon__iQnul img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.topbar_userDropdown__PCUUi {
  position: absolute;
  top: 60px;
  right: 0;
  width: max-content;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 100;
  animation: topbar_fadeIn__Fnyvx 0.2s ease-in-out;
}

.topbar_userWrapper__iTr5o {
  position: relative;
}

.topbar_dropdownHeader__2nbm5 {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  cursor: pointer;
}

.topbar_userProfileImage__VU8EC {
  width: 35px;
  height: 35px;
}

.topbar_dropdownHeader__2nbm5 img {
  height: 100%;
  width: 100%;
  border-radius: 100%;
  object-fit: cover;
}

.topbar_dropdownHeader__2nbm5 p {
  font-size: 14px;
  margin: 0;
  color: var(--grey);
}

/* Logout Button */
.topbar_logoutBtn__Azmm\\+ {
  width: 100%;
  padding: 10px;
  background: #0A0A0A;
  border: none;
  color: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: 0.2s;
}

@keyframes topbar_fadeIn__Fnyvx {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 1024px) {
  .topbar_topbarContainer__has3k {
    display: none;
  }
}

@media (max-width: 550px) {
  .topbar_topbarContainer__has3k {
    flex-direction: column;
    gap: 10px;
    padding: 10px 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/topbar.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,MAAM;EACN,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,YAAY;EACZ,gDAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;AACF","sourcesContent":[".topbarContainer {\n  width: 100%;\n  background: white;\n  border-bottom: 1px solid #e5e5e5;\n  padding: 15px 25px;\n  height: 67px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: fixed;\n  top: 0;\n  z-index: 9;\n}\n\n/* Left (Admin Title) */\n.topbarLeft h2 {\n  font-size: 22px;\n  font-weight: 600;\n  margin: 0;\n}\n\n/* Right Icons */\n.topbarRight {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.icon {\n  font-size: 22px;\n  cursor: pointer;\n  color: #333;\n  transition: 0.2s ease;\n}\n\n.icon:hover {\n  color: #2d7a46;\n}\n\n.notificationIcon {\n  height: 25px;\n  width: 25px;\n}\n\n.notificationIcon img {\n  height: 100%;\n  width: 100%;\n}\n\n.userIcon {\n  height: 40px;\n  width: 40px;\n  border: 1px solid black;\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.userIcon img {\n  height: 100%;\n  width: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.userDropdown {\n  position: absolute;\n  top: 60px;\n  right: 0;\n  width: max-content;\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  border-radius: 10px;\n  padding: 15px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n.userWrapper {\n  position: relative;\n}\n\n.dropdownHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 15px;\n  cursor: pointer;\n}\n\n.userProfileImage {\n  width: 35px;\n  height: 35px;\n}\n\n.dropdownHeader img {\n  height: 100%;\n  width: 100%;\n  border-radius: 100%;\n  object-fit: cover;\n}\n\n.dropdownHeader p {\n  font-size: 14px;\n  margin: 0;\n  color: var(--grey);\n}\n\n/* Logout Button */\n.logoutBtn {\n  width: 100%;\n  padding: 10px;\n  background: #0A0A0A;\n  border: none;\n  color: white;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: 0.2s;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .topbarContainer {\n    display: none;\n  }\n}\n\n@media (max-width: 550px) {\n  .topbarContainer {\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topbarContainer": `topbar_topbarContainer__has3k`,
	"topbarLeft": `topbar_topbarLeft__41sNg`,
	"topbarRight": `topbar_topbarRight__NZOkz`,
	"icon": `topbar_icon__j3uYA`,
	"notificationIcon": `topbar_notificationIcon__E30Yo`,
	"userIcon": `topbar_userIcon__iQnul`,
	"userDropdown": `topbar_userDropdown__PCUUi`,
	"fadeIn": `topbar_fadeIn__Fnyvx`,
	"userWrapper": `topbar_userWrapper__iTr5o`,
	"dropdownHeader": `topbar_dropdownHeader__2nbm5`,
	"userProfileImage": `topbar_userProfileImage__VU8EC`,
	"logoutBtn": `topbar_logoutBtn__Azmm+`
};
export default ___CSS_LOADER_EXPORT___;
